<div class="subwrapper">
    <mat-progress-bar *ngIf="loader" mode="indeterminate" color="primary" style="position: fixed; top: 0; left: 0; width: 100%; z-index: 9999;"></mat-progress-bar>
    <div class="sub-title wrapper">
        <!-- <h2>Order List</h2> -->
         <h2>{{ heading }}</h2>
        <!-- <button mat-button class="add_btn" (click)="addCalendarOfEvents()">
          Add Events
        </button> -->
    </div>
    <div class="mainwrapper orderlist_wrapper wrapper" *ngIf="tabledatatalist != null && tabledatatalist.length > 0">
        <div class="list-style1">
            <div class="taxonomies_liststyle" [ngClass]="listprogressBar == true ? 'hide' : 'show'">
                <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>
                <lib-listing class="adminlisttable_v1" *ngIf="tabledatatalist != null && tabledatatalist.length > 0"
                    [datasource]="tabledatatalist" [skip]="tabledata_header_skip"
                    [modify_header_array]="modify_header_array" [apiurl]="base_api_url"
                    [deleteendpoint]="deleteendpoint" [updateendpoint]="updateendpoint"
                    [date_search_source]="date_search_source" [date_search_endpoint]="date_search_endpoint"
                    [sourcedata]="tablename" [editroute]="editroute" [statusarr]="statusarray"
                    [search_settings]="search_settings" [searchendpoint]="searchendpoint" [sortdata]="sortdata"
                    [datacollection]="datacollection" [date_search_source_count]="date_search_source_count"
                    [libdata]="libdata" [limitcond]="limitcond" [customlistenbutton]="customlistenbutton"
                    [updatetable]="orderList_updatetable" (onLiblistingButtonChange)="onLiblistingButtonChange($event)"
                    (onLiblistingChange)="listenLiblistingChange($event)">
                </lib-listing>
            </div>
          
        </div>
    </div>
      <div *ngIf="!(tabledatatalist.length > 0)" class="noFoundTextinner">
                <span>Oops !!</span>
                <p> NO Record Found</p>
            </div>
</div>